import { useRoutes } from '@/shared/routes';

export const epkRoutes = [
  {
    path: useRoutes.EPK_LIST_PATH,
    name: useRoutes.EPK_LIST_NAME,
    component: () => import('@/pages/EpkList'),
  },
  {
    path: useRoutes.EPK_ITEM_PATH,
    name: useRoutes.EPK_ITEM_NAME,
    component: () => import('@/pages/HouseholdBookPage'),
  },
];
